<script setup lang="ts">
import { useVariant } from "@/common/store"
import { onMounted } from "vue"
import commonRepository from "@/common/repository/CommonRepository"

const variant = useVariant()

onMounted(async () => {
    variant.set(await commonRepository.getVariant())
})
</script>

<template>
    <RouterView />
</template>

<style>
@import "@quasar/extras/material-icons/material-icons.css";
@import "quasar/src/css/index.sass";
@import "vue3-toastify/dist/index.css";
</style>
